import { render, staticRenderFns } from "./warranty-activation.vue?vue&type=template&id=6ff07c35&"
import script from "./warranty-activation.vue?vue&type=script&lang=ts&"
export * from "./warranty-activation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports